import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

/**
 * Get paginated list of tagboards.
 * @param {Object} [opts] - Options to filter/paginate results.
 * @returns {Promise<Object>} API Response with `tagboards` and `total`.
 */
export const getTagboards = async (opts = {}) => {
  const { boards, total } = await fetch(getUrl('/boards'), { query: opts });

  return { tagboards: boards, total };
};

/**
 * Get unique list of tags assigned to boards for the current owner.
 * @returns {Promise<Object>} API Response with `tags`.
 */
export const getTags = () => (
  fetch(getUrl('/boards/tags'))
);

/**
 * Get list of tagboards by ID(s).
 * @param {Array<Number>} boardIds - List of boards to fetch.
 * @returns {Promise<Object>} API Response with `tagboards`.
 */
export const getMultipleTagboards = async (boardIds = []) => {
  if (!boardIds.length) {
    return {
      tagboards: [],
    };
  }

  const { boards } = await fetch(
    getUrl('/boards/many'),
    { query: { ids: boardIds.join(',') } },
  );

  return { tagboards: boards };
};
